module.exports = __webpack_public_path__ + "static/img/business_chair_h4_r.6ad828d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/parts/simple/business_chair_h4_r.png
// module id = TfXi
// module chunks = 3